// @ts-nocheck: converted from JS

import ImportMeasurements from '@/components/Studies/Import/Show';

export default ImportMeasurements;
